import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { FileDown } from "lucide-react";
import { toast } from "sonner";

/** Per-widget CSV/Excel export — sends exactly what the widget displays. */
export default function WidgetExport({ title, headers, getRows }) {
  const [busy, setBusy] = useState(false);
  const run = async (format) => {
    setBusy(true);
    try {
      const res = await api.post("/leads/analytics/widget-export",
        { title, headers, rows: getRows(), format }, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}.${format}`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success(`${title} exported (.${format})`);
    } catch {
      toast.error("Widget export failed");
    } finally {
      setBusy(false);
    }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="h-6 px-2 text-[10px] text-slate-500 print:hidden"
                disabled={busy} data-testid={`widget-export-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
          <FileDown className="w-3 h-3 mr-1" /> Export
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => run("csv")}>CSV</DropdownMenuItem>
        <DropdownMenuItem onClick={() => run("xlsx")}>Excel</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
